import "./style.css";

export const AuditQuestion = ({ title = "", choices = [], onChange = () => {}, name = "" }) => {
  return (
    <div className="section white-box audit-questions-component ">
      <p className="text-xl text-center">{title}</p>
      <br />

      <div className={`audit-choices ${choices.length == 2 ? "two-per-row" : ""}`}>
        {choices.map((i, idx) => (
          <div className="audit-choices__option" key={idx}>
            <label htmlFor={`${i.name}`}>
              <input
                onClick={() => {
                  onChange(i.value);
                }}
                id={`${i.name}`}
                type="radio"
                name={name}
                value={i.value}
              />
              {i.name}
            </label>
          </div>
        ))}
      </div>

      <br />
    </div>
  );
};
